<div id="d-map"></div>
<div class="bg-map"></div>
<div class="view-box detail-box">
    <div class="ctent-view ctent-detail">
      <span class="btn-back" (click)="backView()"></span>
      <div class="info-detail clearfix">
        <div class="img-detail">
          <img [src]="photo" id="image-area" onError="src='assets/images/no-image-big.png'" alt="Area">
        </div>
        <div class="text-detail">
          <div class="title-detail clearfix">
            <p class="tit-detail">{{ name }}{{ 'is' | translate }}
              <span [ngClass]="color">{{ status }}</span>
            </p>
            <div class="share-social">
              <span id="b-share" class="btn-share" (click)="showShare()"></span>
              <ul [ngClass]="{'show-share' : isShare === true }" class="list-share clearfix">
                <li class="facebook" (click)="shareFacebook()">
                  <i class="fa fa-facebook" aria-hidden="true"></i>
                </li>
                <li class="twitter">
                  <a [href]="'http://www.twitter.com/intent/tweet?text=' + name + '&hashtags=' + status + '&url=' + link + '&via=HUSHCITYapp'">
                    <i class="fa fa-twitter" aria-hidden="true"></i>
                  </a>
                </li>
                <li class="linkedin" shareButton="linkedin">
                  <i class="fa fa-linkedin" aria-hidden="true"></i>
                </li>
              </ul>
            </div>
          </div>
          <div class="ctent-info">
            <div [ngClass]="{ 'no-audio' : audio === '' }">
              <audio id="detail-audio">
                <source [src]="audio" [type]="'audio/' + ext"> {{ 'Your browser does not support the audio element.' | translate }}
              </audio>
              <div id="virtual" class="media">
                <div id="media-fill" (click)="changeTimeline($event)"></div>
                <div id="media-thumb"></div>
                <span id="media-control" class="media-play"></span>
              </div>
            </div>
            <div class="time">{{ time }}</div>
            <div class="address-detail">{{ address }}</div>
            <div [ngClass]="legend < 10 ? 'bd-color0' + legend : 'bd-color' + legend" class="legend-noise">{{ noise }}<span>dB(A)</span></div>
            <div class="btn-view-feedback">
              <a routerLink="/area-detail/feedback/{{ id }}">
                <span>{{ 'View User Feedback' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="map-detail"></div>
    </div>
  </div>